import { render, staticRenderFns } from "./AlertMessage.vue?vue&type=template&id=ba86b2ae&scoped=true&"
import script from "./AlertMessage.vue?vue&type=script&lang=ts&"
export * from "./AlertMessage.vue?vue&type=script&lang=ts&"
import style0 from "./AlertMessage.vue?vue&type=style&index=0&id=ba86b2ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba86b2ae",
  null
  
)

export default component.exports